import React from 'react';

import StatusCell from '../../../components/Badge/StatusCell';
import Table from '../../../components/Table/Table';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';

const ConflictDetails = () => {
  return (
    <Table
      tableTitle='CONFLICT DETAILS'
      tableHeader={{
        Date: 'date',
        'Company Involved': 'companyInvolved',
        'Receiving Company': 'receivingCompany',
        'Resolution Status': 'resolutionStatus',
      }}
      tableDataSourceUrl='authentication-service/ba/v1/company/users/warehouse'
      cellsCustomComp={{
        date: <TableDateFormatter dataKey='date' />,
        resolutionStatus: <StatusCell statusKey='resolutionStatus' />,
      }}
      // mobileCellComp={<UserProfileManagementCell />}
      // showPaginationControl={false}
    />
  );
};

export default ConflictDetails;
